import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from 'react-router-dom';
import YadavBhattarai from "../media/ManagementTeam/YADAV BHATTARAI.png";
import UdeshKhadka from "../media/ManagementTeam/UDESH KHADKA.png";
import JibanNeupane from "../media/ManagementTeam/male.png"

import { ArrowLeftOutlined } from '@ant-design/icons';
const Testimonials = () => {
  const [searchParams] = useSearchParams();
  const data = searchParams.get('from') || 'No Data Passed';
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  if (data === "UdeshKhadka") {
    return (
      <div className="about-container">
        <div className="content-left">
          <p style={{ display: 'flex' }}>
            <ArrowLeftOutlined onClick={goBack}></ArrowLeftOutlined>Go back
          </p>
          <img
            src={UdeshKhadka}
            alt="Profile"
            className="profile-picture"
          />
          <p>Dear Valued Investors and Clients,</p>
          <p>
            We extend our heartfelt gratitude to each of you for your continued trust and support. Your confidence in our vision and strategy inspires us to achieve greater heights as we work towards delivering sustained growth and value creation.
          </p>
          <p>
            At Brahma Jyoti Holdings Limited (BJHL), we remain steadfast in our commitment to:
          </p>
          <ul className="letter-list">
            <li>
              <strong>Transparency:</strong> Keeping you informed with accurate and timely updates.
            </li>
            <li>
              <strong>Innovation:</strong> Pursuing opportunities that align with our values and enhance returns.
            </li>
            <li>
              <strong>Sustainability:</strong> Embracing practices that contribute to long-term social and economic impact.
            </li>
          </ul>
          <p>
            As we look to the future, we are confident in our ability to navigate challenges and capitalize on emerging opportunities. Together, we will continue building a robust and resilient organization that benefits all stakeholders.
          </p>
          <p>
            Thank you once again for your partnership and trust in Brahma Jyoti Holdings Limited. Please feel free to reach out for any inquiries or updates—we value your feedback and collaboration.
          </p>
        </div>
        <div className="letter-footer">
          <p>Warm regards,</p>
          <p>
            <strong>Udesh Khadka</strong> <br />
            CEO/BOD <br />
            Brahma Jyoti Holdings Limited
          </p>
        </div>
      </div>
    )
  } else if (data === "YadavBhattarai") {
    return (
      <div className="about-container">
        <div className="content-left">
          <p style={{ display: 'flex' }}>
            <ArrowLeftOutlined onClick={goBack}></ArrowLeftOutlined>Go back
          </p>
          <img
            src={YadavBhattarai}
            alt="Profile"
            className="profile-picture"
          />
          <p>Dear Shareholders, Partners, and Stakeholders,</p>
          <p>
            I am pleased to reflect on our continued progress and the successful expansion of our holdings company into diverse sectors, including equities, agriculture, and financial consultancy.
          </p>
          <p>
            Over the past year, our investment portfolio has shown significant growth, particularly in the stock markets, where we have strategically positioned ourselves to capitalize on emerging opportunities. Our investment team remains dedicated to identifying high-potential assets, with a focus on sustainable and long-term value creation. This disciplined approach has allowed us to navigate market fluctuations and continue delivering robust returns for our shareholders.
          </p>
          <p>
            In addition to our financial market activities, we have made notable strides in the agriculture sector. Our agriculture ventures are aligned with our commitment to environmental sustainability and social responsibility.
          </p>
          <p>
            Moreover, our financial consultancy arm has expanded its footprint, providing expert guidance to clients in managing risks, optimizing financial strategies, and navigating complex market landscapes. This segment of our business has seen strong demand, driven by our team’s expertise and a growing need for sound financial advice in today’s rapidly evolving economy.
          </p>
          <p>
            As we look to the future, we remain committed to diversifying our portfolio further, enhancing operational efficiencies, and maintaining a clear focus on generating long-term value for our stakeholders. The strength of our team, the depth of our investments, and our commitment to responsible business practices will continue to drive our success in the years ahead.
          </p>
          <p>
            Thank you for your continued trust and support. We are excited for what the future holds and look forward to sharing our journey with you.
          </p>
          <div >
            <p>Sincerely,</p>
            <p>
              <strong>Yadav Bhattarai</strong> <br />
              Chairman <br />
              Brahma Jyoti Holdings Limited
            </p>
          </div>
        </div>

      </div>
    )
  } else if(data === "JibanNeupane"){
    return(
    <div className="about-container">
    <div className="content-left">
      <p style={{ display: 'flex' }}>
        <ArrowLeftOutlined onClick={goBack}></ArrowLeftOutlined>Go back
      </p>
      <img
        src={JibanNeupane}
        alt="Profile"
        className="profile-picture"
      />
      <p>Dear Shareholders, Partners, and Stakeholders,</p>
      <p>
      As the Company Secretary for Brahma Jyoti Holdings Limited, a leading investment and trading firm, my primary responsibility is to ensure that we operate within the framework of applicable laws and regulations. From overseeing compliance with the Securities Board of Nepal (SEBON) guidelines to managing the filing of annual returns and ensuring transparency in shareholder communications,
       I work closely with our legal and financial teams to safeguard the company’s interests. My role also extends to advising the board on corporate governance practices, ensuring that decisions made are not only legally sound but also aligned with our long-term vision and values.
      </p>
      <div >
        <p>Warm Regards,</p>
        <p>
          <strong>Jiban Neupane</strong> <br />
          Secretary <br />
          Brahma Jyoti Holdings Limited
        </p>
      </div>
    </div>

  </div>
    )
  }else {
    return (
      <div>

      </div>
    )
  }


}


export default Testimonials;